module.exports = __webpack_public_path__ + "static/media/Pencil.c0ad87fb.svg";